const gprs = {
  moduleTitle: "GPRS Commands",
  actions: {
    view: "View",
    create: "Create",
  },
  permissions: {
    core: "Core",
    gprsManagement: "GPRS Management",
    gprs: "GPRS",
  },
  status: {
    PENDING: "Pending",
    SUCCESSFUL: "Successful",
    FAILED: "Failed",
    TIMED_OUT: "Timed Out",
  },
  failureReasons: {
    offline: "The device was not connected",
    failed: "The device refused the command",
    timeout: "The device did not answer in time",
    expired: "The command waited too long to be sent",
    unsupported: "The device doesn't support this command",
    tracking_unavailable: "The tracking service couldn't take the command",
    not_sent: "The command couldn't be sent",
    no_result: "The command's result was lost",
  },
  seconds: "{{value}} sec",
  noResponse: "No response received",
  list: {
    title: "GPRS Commands",
    subtitle: "Track commands sent to devices and verify their execution result.",
    toolbar: {
      search: "Search",
      searchPlaceholder: "Search...",
      send: "Send new command",
    },
    filters: {
      filters: "Filters",
      status: "Command Status",
      all: "All",
      createdDate: "Created Date",
      createdDatePlaceholder: "Select a date range",
      clearDateRange: "Clear",
      nextMonth: "Next month",
      previousMonth: "Previous month",
    },
    table: {
      company: "Company",
      deviceName: "Device Name",
      imei: "IMEI",
      command: "Command",
      response: "Response",
      executionTime: "Execution Time",
      status: "Command Status",
      createdAt: "Creation Date",
      empty: "No GPRS commands found.",
      error: "Failed to load GPRS commands.",
      loading: "Loading GPRS commands",
      total: "Total {{total}} GPRS",
      rowsPerPageLabel: "Rows per page",
      nextPage: "Next page",
      previousPage: "Previous page",
      pagination: "Rows per page",
      sortAscending: "Sort ascending",
      sortDescending: "Sort descending",
      actionMenu: "Actions",
    },
  },
  detail: {
    title: "Last Sent Response Details",
    subtitle: "Configure and export direct command packets for the vehicle",
    close: "Close",
    company: "Company",
    deviceName: "Device Name",
    imei: "IMEI",
    command: "Command",
    response: "Response",
    executionTime: "Execution Time",
    status: "Command Status",
    createdAt: "Creation Date",
  },
  send: {
    title: "Send GPRS Command",
    subtitle: "Configure and export direct command packets for the vehicle",
    close: "Close",
    company: "Company",
    companyPlaceholder: "Select one or more companies",
    companySearch: "Search companies",
    companyEmpty: "No companies found.",
    imei: "IMEI Number",
    imeiPlaceholder: "Select one or more devices",
    imeiSearch: "Search by IMEI",
    imeiEmpty: "No matching devices.",
    selectCompanyFirst: "Select a company first to see its devices.",
    presetNotFound: "No active device with IMEI {{imei}} was found. Pick a device.",
    allDevices: "All",
    allDevicesChip: "All devices",
    noAsset: "No asset",
    remove: "Remove {{name}}",
    command: "Command",
    commandPlaceholder: "Select or write a command",
    commandSearch: "Search commands",
    commandEmpty: "No command is supported by the selected devices.",
    commandHint: "Pick an existing command or write a new one",
    supportedBy: "Supported by {{count}} of the selected devices",
    customCommandOption: "Write a new command",
    customCommand: "Command text",
    customCommandPlaceholder: "Type the command",
    parameters: "Parameters",
    parametersPlaceholder: "Shown when a command needs parameters",
    parametersHint: "Parameters appear automatically when you pick a command",
    customParameters: "Parameters (optional)",
    customParametersPlaceholder: "Type the command's parameters",
    customParametersHint: "Sent after the command, separated by a space",
    errors: {
      parameterRange: "Enter a value between {{min}} and {{max}}.",
      parameterLength: "Enter between {{min}} and {{max}} characters.",
      parameterFormat: "This value isn't in the expected format.",
      wholeNumber: "Enter a whole number.",
      customText: "Use English letters, digits and symbols only, up to {{max}} characters.",
      commandUnsupported: "None of the selected devices supports this command. Pick another.",
      catalogFailed: "Couldn't load the commands. Try again.",
    },
    cancel: "Cancel",
    submit: "Send",
    success: "Command sent to {{count}} device(s). Each status updates when the device answers.",
    partialSuccess: "Command sent to {{sent}} of {{total}} devices; {{failed}} failed.",
  },
};

export default gprs;
